export default __webpack_public_path__ + "static/media/emailNew.36809e58.svg";